'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	BORDER_WIDTH_BOUNDS = { // TODO: read from the map editor model, or common require!
		max: 10,
		min: 0
	};
mmWidgets.fn.themeStyleBorderSizeWidget = function (mapThemeModel) {
	const getCurrentSize = (themeNodeStyle) => {
			const size = mapThemeModel.getThemeAttribute(['node'], [themeNodeStyle, 'default'], ['border', 'line', 'width']);
			return parseFloat(size) || BORDER_WIDTH_BOUNDS.min;
		},
		setSize = (themeNodeStyle, size) => {
			mapThemeModel.overrideThemeAttribute(['node', themeNodeStyle, 'border', 'line', 'width'], size || undefined);
		},
		incrementBorderSize = (themeNodeStyle, increment) => {
			const current = getCurrentSize(themeNodeStyle),
				newSize = current + increment;

			if (newSize < BORDER_WIDTH_BOUNDS.min) {
				setSize(themeNodeStyle, BORDER_WIDTH_BOUNDS.min);
			} else if (newSize > BORDER_WIDTH_BOUNDS.max) {
				setSize(themeNodeStyle, BORDER_WIDTH_BOUNDS.max);
			} else {
				setSize(themeNodeStyle, newSize);
			}
		},
		increment = function (themeNodeStyle) {
			incrementBorderSize(themeNodeStyle, 1);
		},
		decrement = function (themeNodeStyle) {
			incrementBorderSize(themeNodeStyle, -1);
		},
		reset = (themeNodeStyle) => {
			setSize(themeNodeStyle, 0);
		},
		actions = {increment, decrement, reset};

	return mmWidgets.each(this, function () {
		const widget = this;
		widget.click(() => {
			const themeNodeStyle = widget.attr('data-mm-theme-border-size'),
				operation = widget.attr('data-mm-border-size');
			actions[operation](themeNodeStyle);
		});
	});
};

